<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('certificateOperationPrint.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('certificateOperationPrint.pageTitle'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper class="ts-flex ts-items-center ts-justify-between">
        <div>
          <ts-button color="info" outline @click="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <ts-button
            class="btn ml-2"
            :disabled="!checkedStudent.length > 0"
            outline
            color="primary"
            @click="previewPdf"
          >
            {{ $t('certificateOperationPrint.previewPdf') }}
          </ts-button>
        </div>
        <div class="ts-flex ts-justify-end ts-space-x-2">
          <a-input
            v-model="search"
            v-tooltip="$t('search')"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
          <ts-button
            outline
            v-tooltip="$t('filter')"
            @click.prevent="visible = true"
          >
            <i class="fa fa-filter"></i>
          </ts-button>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          @check-items="checkItem"
          :showCheckbox="true"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-nowrap">
              {{
                record.student.branch
                  ? record.student.branch.branch_name_en
                  : ''
              }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.student ? record.student.full_name_en : '' }}
            </td>
            <td class="ts-whitespace-nowrap ts-text-center">
              {{ record.student ? record.student.gender : '' }}
            </td>
            <td class="ts-text-center ts-whitespace-nowrap">
              {{ record.student ? record.student.phone : '' }}
            </td>
            <td class="ts-text-center ts-whitespace-nowrap">
              {{ record.academic_year ? record.academic_year.ac_year : '' }}
            </td>
            <td class="ts-text-left ts-whitespace-nowrap">
              {{
                record.sub_program ? record.sub_program.acps_name_foreign : ''
              }}
            </td>
            <td class="ts-text-left w-whitespace-nowrap">
              {{
                record.printed_by.employee
                  ? record.printed_by.employee.name_en
                  : ''
              }}
            </td>
            <td class="ts-text-center w-whitespace-nowrap">
              {{ record.printed_at }}
            </td>
            <td class="text-center ts-whitespace-nowrap">
              <!-- v-if="!record.is_printed" -->
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="text-danger"
                @click.prevent="print(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      :zIndex="1020"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t('certificateOperationPrint.branch')
        }}</label>
        <ts-branch-filter @filter="value => (branch_id = value)" />
      </div>
    </a-drawer>
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('certificateOperationPrint.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="fetchData"
      :zIndex="1020"
      :footer="null"
      width="1080px"
    >
      <from-action @cancel="() => (showForm = false)" @fetchData="fetchData" />
    </a-modal>
    <a-modal :title="$t('pdf')" width="70%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import FromAction from './form.vue'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'certificateOperationPrintIndex',
  components: {
    FromAction
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      src: '',
      showForm: false,
      show_pdf: false,
      visible: false,
      checkedStudent: [],
      ac_year: null,
      branch_id: []
    }
  },
  computed: {
    ...mapState('certificateOperationPrint', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.certificateOperationPrint.search
      },
      set(newValue) {
        this.$store.commit('certificateOperationPrint/SET_SEARCH', newValue)
        this.$store.commit('certificateOperationPrint/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('certificateOperationPrint.branch'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.studentName'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.sex'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.phone'),
          style: 'white-space: nowrap;text-align:center;'
        },
        {
          name: this.$t('certificateOperationPrint.academicYear'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.subProgram'),
          style: 'text-align:left;white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.printedBy'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('certificateOperationPrint.printedDate'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 5%;'
        }
      ]
    }
  },
  methods: {
    async fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('certificateOperationPrint/fetch', 
        Object.assign(
            {
              page: this.pagination.currentPage
            },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    print(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('certificateOperationPrint/printPdf', [record.student_id])
        .then(response => {
          this.src = response.url
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    previewPdf() {
      this.show_pdf = true
      this.waiting = true
      this.$store
        .dispatch('certificateOperationPrint/printPdf', this.checkedStudent)
        .then(response => {
          this.src = response.url
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    checkItem(value) {
      this.checkedStudent = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedStudent.push(element.student_id)
        })
      }
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('certificateOperationPrint/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
